import React from "react";

const Performance = ({style = {}, size = "36", className = "", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g clipPath="url(#performance_icon)">
            <path
                fill="#60B158"
                d="m26.286 8.023-5.011 7.229a5.793 5.793 0 0 0-6.552-.019l-4.98-7.21h.002a24.566 24.566 0 0 0 16.536 0h.005ZM18.014 8.021a3.017 3.017 0 0 0 3.023-3.01A3.017 3.017 0 0 0 18.014 2a3.017 3.017 0 0 0-3.023 3.01 3.017 3.017 0 0 0 3.023 3.011Z"
            />
            <path
                fill="#FF6961"
                d="M18.005 19.972h.01l-.015.03-.014-.03.019-.001ZM32.513 18.864a24.349 24.349 0 0 0-8.3 14.245l-3.758-7.931a5.769 5.769 0 0 0 2.41-2.123 5.736 5.736 0 0 0 .88-3.524l8.768-.667Z"
            />
            <path
                fill="#FF6961"
                d="M30.976 30.51A3.017 3.017 0 0 0 34 27.497a3.017 3.017 0 0 0-3.023-3.01 3.017 3.017 0 0 0-3.023 3.01 3.017 3.017 0 0 0 3.023 3.011Z"
            />
            <path
                fill="#007AFF"
                d="m15.542 25.19-3.752 7.92a24.35 24.35 0 0 0-8.302-14.246l8.742.665a5.736 5.736 0 0 0 .885 3.537 5.77 5.77 0 0 0 2.427 2.124ZM18.004 19.971l-.005.007-.005-.007h.01Z"
            />
            <path
                fill="#007AFF"
                d="M5.024 30.51a3.017 3.017 0 0 0 3.023-3.012 3.017 3.017 0 0 0-3.023-3.01A3.017 3.017 0 0 0 2 27.498a3.017 3.017 0 0 0 3.023 3.011Z"
            />
            <path
                fill="#FFA700"
                d="m17.986 22.395-2.478 1.381.553-2.774-2.085-1.92 2.82-.333 1.19-2.568 1.188 2.568 2.82.333-2.085 1.92.553 2.774-2.476-1.381Z"
            />
        </g>
        <defs>
            <clipPath id="performance_icon">
                <path fill="#fff" d="M2 2h32v31.111H2z" />
            </clipPath>
        </defs>
    </svg>
);

export default Performance;